import styled, { createGlobalStyle } from "styled-components";
import BGimage from "./images/bg.jpg";

export const GlobalStyle = createGlobalStyle`
    html {
        height: 100%;

    }        

    body {
        background-image: url(${BGimage});
        background-size: cover;
        margin: 0;
        padding: 0 20px;
        display: flex;
        justify-content: center;
    }

    * {
        box-sizing: border-box;
    }

`;

export const Wrapper = styled.div`
display: flex;
flex-direction: column;
align-items: center;

> p {
    color: #fff;

}

.score {
    color: rgb(194, 94, 78);
    font-size: 2rem;
    margin: 0;
}

h1 {
    font-family: Fascinate Inline, Haettenschweiler, 'Arail Narrow Bold',
    background-image: linear-gradient(180deg, #fff, #000);
    background-size: 100%;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: #fff;
    -moz-background-clip: text;
    -moz-text-fill-color: transparent;
    filter: drop-shadow(4px 3px rgb(194, 94, 78));
    font-size: 70px;
    text-align: center;
    margin: 20px;
    
}

.start, .next {
    cursor: pointer;
    background: linear-gradient(180deg, #ffffff, #ffcc91);
    border: 2px solid #d38558;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    height: 40px;
    margin: 20px 0;
    padding: 0 40px;
  }
  .start {
    max-width: 200px;
  }
`;
